import { Drawer, Flex, Text, useToast } from '@driftt/dds'
import React, { useRef, useState } from 'react'

import { formatTime } from 'utils/moment'

import { configByType } from './constants'
import { PromptContainer } from './PromptContainer'
import { TextareaWithButton } from './TextareaWithButton'
import { useValidations } from './useValidations'
import { Validation } from './Validation'
import {
  StyledInfoContainer,
  StyledScrollbarHiddenContainer,
} from './ValidationDrawer.styles'

export const ValidationDrawer = ({
  open,
  onClose,
  savedValidaton,
  type,
  onAction,
}: {
  open: boolean
  onClose: () => void
  /** Text either description, guideline or exit confirmation question */
  savedValidaton?: string
  type: keyof typeof configByType
  onAction: (prompt: string, replyGuidelines?: string) => void
}) => {
  const toast = useToast()
  const [promptInput, setPromptInput] = useState('')
  const bottomRef = useRef<null | HTMLDivElement>(null)
  const config = configByType[type]
  const scrollToBottom = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({
        block: 'end',
        behavior: 'smooth',
      })
    }
  }
  const { validations, validate } = useValidations({
    type,
    onSuccess: () => {
      // Handle success
      setPromptInput('')
      scrollToBottom()
    },
    onError: () => {
      toast({
        variant: 'error',
        message: `Failed to validate ${config.title.toLowerCase()}.`,
      })
    },
  })

  React.useEffect(() => {
    scrollToBottom()
  }, [bottomRef])

  return (
    <Drawer.Root open={open} onClose={onClose}>
      <Drawer.Dialog>
        <Drawer.Title title={config.title} />
        <Drawer.Content>
          <StyledScrollbarHiddenContainer direction="column">
            <StyledInfoContainer>{config.info}</StyledInfoContainer>
            {savedValidaton && (
              <div>
                <Text variant="bodyBold" css={{ marginBottom: '$1' }}>
                  Current {config.title.toLowerCase()}
                </Text>
                <PromptContainer cssStyles={{ marginBottom: '$3' }}>
                  {savedValidaton}
                </PromptContainer>
              </div>
            )}
            {validations.map(
              (
                { prompt, response, replyGuidelines, validationResponseDate },
                i
              ) => (
                <Validation
                  prompt={replyGuidelines || prompt}
                  response={response}
                  type={type}
                  responseDate={formatTime(validationResponseDate, 'hh:mm A')}
                  onUse={() => {
                    onClose()
                    onAction(prompt, replyGuidelines)
                  }}
                />
              )
            )}

            <div ref={bottomRef}></div>
          </StyledScrollbarHiddenContainer>
        </Drawer.Content>
        <Drawer.Actions>
          <Flex direction="row" alignItems="center" width="100%">
            <TextareaWithButton
              buttonLabel="Send"
              placeholder={configByType[type].placeholder}
              value={promptInput}
              // disabled={isSending}
              // loading={isSending}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setPromptInput(e.target.value)
              }
              onClickButton={() => validate(promptInput)}
            />
          </Flex>
        </Drawer.Actions>
      </Drawer.Dialog>
    </Drawer.Root>
  )
}
